<div class="row m-2 exam-start-wrap">
  <div class="col-md-3 user_exam_type">
    <div class="media align-items-center">
      <!-- <a href="#" class="avatar rounded-circle mr-3">
          <img alt="Image placeholder" src="../../assets/img/theme/bootstrap.jpg">
      </a> -->
      <div class="media-body exam-start-wrap">
        <h4><span class="name m-0">{{exam.name}}</span></h4>
      </div>
    </div>
  </div>
  <div *ngIf="!exam.selfschedule" class="col-md-2 mt-2 exam-start-wrap">
    <h5>{{this.localexamdate | date:'medium'}}</h5>
  </div>
  <div class="col-md-2 mt-2 exam-start-wrap">
    <h5>{{languageService.examTypeTranslation(exam.examtype)}}</h5>
  </div>
<div class="col-md-2 exam-start-wrap ">
  <ng-container *ngIf="exam.duration > 0; else noDuration">
    <!-- Show countdown or static duration -->
    <ng-container *ngIf="showTimer; else staticDuration">
      <div #countdownWrapper>
        <countdown #countdown [config]="{ leftTime: exam.timeLeft }">
        </countdown>
      </div>
    </ng-container>
    <!-- Static duration -->
    <ng-template #staticDuration>
      <h5 class="mt-2">{{ exam.duration }} {{ language.minutes }}</h5>
    </ng-template>
  </ng-container>
  <!-- Duration not available -->
  <ng-template #noDuration>
    <h5 class="mt-2 pl-3">Untimed</h5>
  </ng-template>
</div>
  <div *ngIf="!!exam.examscorestring && !isloading" class="col-md-1 mt-2 exam-start-wrap">
    <h5>{{exam.examscorestring}}</h5>
  </div>
  <div class="col-md-2 exam-buttons h5">
    <!-- remove class m-0 p-0 -->

    <ng-template [ngIf]="this.isinterviewexam">
      <button *ngIf="!exam.useSEB || (exam.useSEB && this.runningInSEB); else sebInstructionsButton_Start" type="button"
        [disabled]="!exam.canstart" (click)="getInstructions()" class="btn btn-sm  btn-success statusbtn"
         [attr.aria-label]="language.joinInterviewExam + ': ' + exam.name + ', ' +
         language.examDate + ': ' + localexamdate + ', ' +
         languageService.examTypeTranslation(exam.examtype) + ', ' + language.examDuration + ': ' + ' ' + language.minutes">
        {{language.join}}
      </button>

      <ng-template #sebInstructionsButton_Start>
        <button type="button" (click)="goToSEBInstructionsPage()" class="btn btn-sm  btn-success statusbtn"
        [attr.aria-label]="language.takeInterviewExamSEB + ': ' + exam.name + ', ' +
        language.examDate + ': ' + (this.localexamdate | date:'medium') + ', ' +
        language.examType + ': ' + languageService.examTypeTranslation(exam.examtype) + ', ' + language.examDuration + ': ' + exam.duration + ' ' + language.minutes">
          {{language.takeExam}}
        </button>
      </ng-template>
    </ng-template>


    <ng-template [ngIf]="this.exam.status==pending && !isloading && !exam.selfschedule && exam.examtype!='Interview'">
      <button *ngIf="!exam.useSEB || (exam.useSEB && this.runningInSEB); else sebInstructionsButton_Start" type="button"
        [disabled]="!exam.canstart" (click)="getInstructions()" class="btn btn-sm  btn-success statusbtn" [id]="'startbtn_' + exam.scheduleid"
        [attr.aria-label]="language.startExam + ': ' + exam.name + ', ' + 
        language.examDate + ': ' + (this.localexamdate | date:'medium') + ', ' +
        language.examType + ': ' + languageService.examTypeTranslation(exam.examtype) + ', ' + language.examDuration + ': ' + exam.duration + ' ' + language.minutes">
        {{language.start}}
      </button>

      <ng-template #sebInstructionsButton_Start>
        <button type="button" (click)="goToSEBInstructionsPage()" class="btn btn-sm  btn-success statusbtn"
         [attr.aria-label]="language.takeExamSEB + ': ' + exam.name + ', ' +
         language.examDate + ': ' + (this.localexamdate | date:'medium') + ', ' +
         language.examType + ': ' + languageService.examTypeTranslation(exam.examtype) + ', ' + language.examDuration + ': ' + exam.duration + ' ' + language.minutes">
          {{language.takeExam}}
        </button>
      </ng-template>
    </ng-template>

    <ng-template [ngIf]="!isloading && this.iscontinue">
      <button type="button"
        *ngIf="!exam.useSEB || (exam.useSEB && this.runningInSEB); else sebInstructionsButton_Continue" type="button"
        (click)="gotoexam(false)" class="btn btn-sm btn-primary statusbtn"
        [attr.aria-label]="language.continueExam + ': ' + exam.name + ', ' +
        language.examDate + ': ' + (this.localexamdate | date:'medium') + ', ' +
        language.examType + ': ' + languageService.examTypeTranslation(exam.examtype) + ', ' + language.examDuration + ': ' + exam.duration + ' ' + language.minutes">
        {{language.continue}}
      </button>

      <ng-template #sebInstructionsButton_Continue>
        <button type="button" type="button" (click)="goToSEBInstructionsPage()"
          class="btn btn-sm btn-primary statusbtn"
          [attr.aria-label]="language.continueExamSEB + ': ' + exam.name + ', ' +
          language.examDate + ': ' + (this.localexamdate | date:'medium') + ', ' +
          languageService.examTypeTranslation(exam.examtype) + ', ' + exam.duration + ' ' + language.minutes">
          {{language.takeExam}}
        </button>
      </ng-template>
    </ng-template>

   
    <div *ngIf="isloading" class="btn btn-sm btn-secondary statusbtn disabled"
     aria-disabled="true">
     <div style="display: inline-block;">{{language.pleaseWait}}...</div>
     <br />
     <!-- <span class="" *ngIf="isloading" style="float: right !important;" role="status" aria-live="polite" [attr.aria-label]="language.loadingWait"> -->
      <!-- <img style="height:30px;"
           src="../../../assets/img/spinner.gif" [alt]="language.loadingWait"/> -->
           <app-loading-spinner [width]="40" [height]="40" [alt]="language.loadingWait"></app-loading-spinner>
      <!-- </span> -->
    </div>
    <div class="sr-only" aria-live="assertive">
      {{ isloading ? language.loadingWait : '' }}
    </div>
    <div tabindex="0" *ngIf="exam.status==finished && !isloading"
      class="btn btn-sm btn-danger statusbtn" [attr.aria-label]="language.youHaveCompleted + ' ' + language.exam + ' ' + exam.name">{{language.finished}}</div>
    <div tabindex="0" type="button" *ngIf="exam.status==timeElapsed && !isloading" class="btn btn-sm btn-danger statusbtn" [attr.aria-label]="language.exam + ' ' +exam.name + ' ' + language.timeElapsed">
      {{language.timeElapsed}}</div>
    <div tabindex="0" type="button" *ngIf="exam.status==disqualified && !isloading"
      class="btn btn-sm btn-danger statusbtn" [attr.aria-label]="language.exam + ' ' +exam.name + ' ' + language.disqualified">{{language.disqualified}}</div>
    <div tabindex="0" type="button" *ngIf="exam.status==stopped && !isloading"
      class="btn btn-sm btn-danger statusbtn" [attr.aria-label]="language.exam + ' ' +exam.name + ' ' + language.stopped">{{language.stopped}}</div>

      
    
    <i *ngIf="exam.proctorerror || exam.passporterror" class="bi bi-info-circle text-danger error-info-button"
       (click)="toggleerror()" role="button" tabindex="0" [attr.aria-label]="language.errorDetails + ' ' + exam.name"></i>

    <!-- Scheduling Button Div -->
    <button *ngIf="exam.selfschedule && exam.status==pending && !isloading && !exam.canstart" type="button"
      (click)="showExamScheduleModal()" class="btn btn-sm btn-primary actionbtn"  [attr.aria-label]="language.scheduleExam + ': ' + exam.name">
      {{language.scheduleExam}}
    </button>
    <button *ngIf="(exam.allowreschedule || exam.allowrescheduleAfter) && exam.status==pending && !isloading"
      type="button" (click)="showExamScheduleModal()" class="btn btn-sm btn-primary actionbtn">
      {{language.reschedule}}
    </button>
    <button *ngIf="exam.candidateCanRetake" type="button" class="btn btn-sm  btn-primary actionbtn" data-toggle="modal" [attr.data-target]="'#restartModal' + exam.examid">
      {{language.retakeExam}}
    </button>

  </div>
</div>

<div *ngIf="showerror" class="mx-auto" style="width:fit-content" role="alert" aria-live="assertive">
  <h5 class="text-danger">{{exam.proctorerror}}</h5>
  <h5 class="text-danger">{{exam.passporterror}}</h5>
</div>

<app-instructions-modal
[modalId]="'instructionsModal' + exam.examid"
[examId]="exam.examid"
[examName]="exam.name"
[company]="instructions.company"
[companyHTML]="companyhtml"
[examHTML]="examhtml"
[webtestHTML]="webtesthtml"
(startExam)="gotoexam($event)"
(cancelExam)="resumeinterval()">
</app-instructions-modal>

<div class="modal fade" id="scheduleModal" tabindex="1" data-backdrop="static" aria-hidden="true" role="dialog"
     style="width: 50% !important; margin-left: 25%;">

  <div class="modal-dialog" style="max-width: 100% !important;">
    <div class="modal-content">
      <div class="modal-header">
        <h4 class="modal-title "> {{language.examSchedule}}</h4>
        <p>{{exam.name}}</p>
      </div>

      <div class="card">

        <div class="card-body">
          <form class="p-2">
            <div class="row">
              <div class="col-md-6">
                <label> {{language.scheduleDate}}</label>

                <div class="form-group" *ngIf="!usedropdown">
                  <input class="form-control" required type="date" (change)="onDateChange($event)" [min]="minDate"
                         [max]="maxDate">
                </div>

                <div class="form-group" *ngIf="usedropdown">
                  <select class="form-control form-select" required (change)="onDateChange($event)">
                    <option value="" disabled selected *ngIf="isDate">{{language.selectDate}} (yyyy-MM-dd)</option>
                    <option value="" disabled selected *ngIf="!isDate">{{language.noAvailableDate}}</option>
                    <option *ngFor="let scheduledDate of availabeDates" [value]="scheduledDate">
                      {{ scheduledDate }}
                    </option>
                  </select>

                </div>
              </div>
              <div class="col-md-6">
                <label>{{language.scheduleTime}}</label>
                <div class="form-group">

                  <select class="form-control form-select" required (change)="onTimeChange($event)">
                    <option value="" disabled selected *ngIf="isTime">{{language.selectTime}}</option>
                    <option value="" disabled selected *ngIf="!isTime">{{language.noAvailableTime}}</option>
                    <option *ngFor="let time of availabeTimes" [value]="time.position">
                      {{ time.displaytime }}
                    </option>
                  </select>

                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-md-6">
                <button type="submit" class="btn form-control btn-primary"
                  [disabled]="!scheduledPosition || !scheduledDate" data-dismiss="modal" (click)="onScheduleClicked()">
                  <span class="" *ngIf="isloading" style="float: right !important;">
                    <!-- <img style="height:30px;" src="../../../assets/img/spinner.gif" />  -->
                     <app-loading-spinner [width]="40" [height]="40"></app-loading-spinner>
                  </span> Schedule{{language.schedule}}
                </button>
              </div>

              <div class="col-md-6">
                <div class=""><input class="form-control btn btn-danger" type="button" id="clear-options"
                    (click)="resumeinterval()" data-dismiss="modal" [value]="language.cancel" /></div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" id="restartModal{{exam.examid}}" data-backdrop="static" aria-labelledby="restartModalLabel" style="width: 50% !important; margin-left: 25%;" role="dialog" aria-modal="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <p class="modal-title" id="restartModalLabel">Reason for Retake</p>
        <button type="button" class="close h3" data-dismiss="modal" aria-label="Close retake dialog">&times;</button>
      </div>
      <div class="modal-body">
        <div class="mb-3">
          <label for="retakeReason" class="form-label">Reason</label>
          <textarea autofocus class="form-control" id="retakeReason" rows="3" required
            [(ngModel)]="retakeReason"></textarea>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal"
          aria-label="Cancel Retake">{{language.cancel}}</button>
        <button type="button" class="btn btn-success" data-dismiss="modal" [disabled]="!retakeReason"
          (click)="retakeExam()">{{language.submit}}</button>
      </div>
    </div>
  </div>
</div>

<ng-template #startingModal let-modal>
    <div class="modal-header">
        <h4 class="modal-title" [id]="'startingExamModalTitle' + this.exam.examid"
            [attr.aria-label]="language.startingYourExam">{{language.startingYourExam}}...</h4>
    </div>
    <div class="modal-body p-0 starting-modal-body">
      <div [id]="'startingExamModalTitle' + this.exam.examid"><b>{{language.pleaseWaitWhileWeAuthenticateYouAndStartYourExam}}.</b></div>
      <div><app-loading-spinner [width]="40" [height]="40"></app-loading-spinner></div>
      <div [hidden]="!this.exam.useproctor || this.exam.skipAIPassportCheck || this.user.skipaifacematching">
        <div>{{language.startingExamKeepEyesOnTheScreen}}.</div>
        <div id="starting-exam-video-div"><video #startingExamVideo autoplay playsinline id="startingExamVideo" class="starting-exam-video"></video></div>
      </div>
    </div>
</ng-template>